/* Glühweinbecher.com — Theme-Skript */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cfg = window.GWB || {};
  cfg.routes = cfg.routes || { cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change", root: "/" };
  cfg.strings = cfg.strings || {};

  var nf = new Intl.NumberFormat(document.documentElement.lang || "de-DE", {
    style: "currency", currency: (cfg.currency || "EUR")
  });
  function money(cents) {
    try { return nf.format((cents || 0) / 100); }
    catch (e) { return ((cents || 0) / 100).toFixed(2) + " €"; }
  }

  /* Netto / Brutto */
  var PMODE_KEY = "gwb_preis_v1";

  function currentMode() {
    return document.documentElement.classList.contains("mode-netto") ? "netto" : "brutto";
  }
  function setMode(mode) {
    if (mode !== "netto" && mode !== "brutto") return;
    var root = document.documentElement;
    root.classList.remove("mode-netto", "mode-brutto");
    root.classList.add("mode-" + mode);
    try { localStorage.setItem(PMODE_KEY, mode); } catch (e) {}
    syncMode();
  }
  function syncMode() {
    var mode = currentMode();
    $$("[data-pmode]").forEach(function (b) {
      var on = b.getAttribute("data-pmode") === mode;
      b.classList.toggle("on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    renderDrawer(lastCart);
  }
  try {
    var saved = localStorage.getItem(PMODE_KEY);
    if (saved === "netto" || saved === "brutto") {
      document.documentElement.classList.remove("mode-netto", "mode-brutto");
      document.documentElement.classList.add("mode-" + saved);
    }
  } catch (e) {}

  function netOf(cents) {
    var v = cfg.vatRate || 0.19;
    return Math.round(cents / (1 + v));
  }
  function shown(cents) { return currentMode() === "netto" ? netOf(cents) : cents; }

  /* Gebinde wechseln */
  function switchVariant(btn) {
    var id = btn.getAttribute("data-variante");
    var scope = btn.closest(".pcard") || btn.closest(".pdp-info") || document;

    $$(".vtab", btn.parentElement).forEach(function (b) {
      b.setAttribute("aria-pressed", b === btn ? "true" : "false");
    });
    $$("[data-fuer]", scope).forEach(function (el) {
      if (el.getAttribute("data-fuer") === id) el.removeAttribute("hidden");
      else el.setAttribute("hidden", "");
    });
    var input = $("[data-variant-input]", scope) || $('input[name="id"]', scope);
    if (input) input.value = id; var card = btn.closest(".pcard"), vb = btn.getAttribute("data-vbild"); if (card && vb) { var im = card.querySelector(".pcard-media img"); if (im) { im.srcset = btn.getAttribute("data-vsrcset") || ""; im.src = vb; } }
  }

  /* Warenkorb */
  var lastCart = null;

  function fetchCart() {
    return fetch(cfg.routes.cart + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; updateCount(c); return c; })
      .catch(function () { return null; });
  }

  function updateCount(cart) {
    if (!cart) return;
    $$("[data-cart-count]").forEach(function (e) {
      e.textContent = cart.item_count;
      e.classList.toggle("zero", cart.item_count === 0);
    });
  }

  function addToCart(form) {
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.classList.add("loading");
    var data = new FormData(form);

    return fetch(cfg.routes.cartAdd + ".js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove("loading");
        if (!res.ok) {
          toast(res.body.description || res.body.message || "Das hat nicht geklappt.");
          return;
        }
        toast((res.body.quantity || 1) + " × " + (res.body.product_title || "") + " " + (cfg.strings.added || ""));
        return fetchCart().then(function () { openDrawer(); });
      })
      .catch(function () {
        if (btn) btn.classList.remove("loading");
        toast("Keine Verbindung zum Warenkorb.");
      });
  }

  function changeLine(key, qty) {
    return fetch(cfg.routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; updateCount(c); renderDrawer(c); return c; });
  }

  /* Schublade */
  function renderDrawer(cart) {
    var body = $("#drawer-body"), foot = $("#drawer-foot");
    if (!body || !foot) return;

    if (!cart || cart.item_count === 0) {
      body.innerHTML = '<div class="empty" style="padding:50px 10px;text-align:center;color:var(--muted)">'
        + "<p>" + (cfg.strings.empty || "Noch nichts ausgewählt.") + "</p></div>";
      foot.innerHTML = "";
      return;
    }

    body.innerHTML = cart.items.map(function (it) {
      var bild = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") + '" alt="">' : "";
      return '<div class="dline">'
        + '<div class="di">' + bild + "</div>"
        + "<div><b>" + escapeHtml(it.product_title) + "</b>"
        + "<small>" + escapeHtml(it.variant_title || "") + "</small>"
        + '<div style="display:flex;align-items:center;gap:8px;margin-top:7px">'
        + '<div class="qty" style="transform:scale(.82);transform-origin:left center">'
        + '<button type="button" data-dq="' + it.key + '" data-d="-1" aria-label="weniger">−</button>'
        + '<input type="number" value="' + it.quantity + '" data-dqi="' + it.key + '" min="1" aria-label="Menge">'
        + '<button type="button" data-dq="' + it.key + '" data-d="1" aria-label="mehr">+</button>'
        + "</div>"
        + '<span style="font-weight:700;font-size:.92rem">' + money(shown(it.final_line_price)) + "</span>"
        + "</div></div>"
        + '<button class="icon-btn" type="button" data-drm="' + it.key + '" aria-label="Position entfernen" style="width:30px;height:30px">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>'
        + "</button></div>";
    }).join("");

    var modeWort = currentMode();
    foot.innerHTML =
      '<div class="sum-row"><span>Zwischensumme (' + modeWort + ")</span><b>" + money(shown(cart.total_price)) + "</b></div>"
      + '<div class="sum-row"><span>Versand</span><b style="font-weight:500;color:var(--muted);font-size:.85rem">kostenlos</b></div>'
      + '<a href="/checkout" class="btn btn-primary btn-block btn-lg" style="margin-top:10px">Zur Kasse · ' + money(cart.total_price) + " brutto</a>"
      + '<a href="' + cfg.routes.cart + '" class="btn btn-quiet btn-block" style="margin-top:6px">Warenkorb bearbeiten</a>';
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function openDrawer() {
    renderDrawer(lastCart);
    var d = $("#drawer");
    if (!d) return;
    d.classList.add("on");
    d.setAttribute("aria-hidden", "false"); d.inert = false;
    var s = $("#scrim"); if (s) s.classList.add("on");
    document.body.style.overflow = "hidden";
  }
  function closeAll() {
    var d = $("#drawer"), m = $("#mobnav"), s = $("#scrim");
    if (d) { d.classList.remove("on"); d.setAttribute("aria-hidden", "true"); d.inert = true; }
    if (m) { m.classList.remove("on"); m.setAttribute("aria-hidden", "true"); m.inert = true; }
    if (s) s.classList.remove("on");
    document.body.style.overflow = "";
  }

  var toastT;
  function toast(msg) {
    var t = $("#toast");
    if (!t) return;
    t.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" '
      + 'stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'
      + escapeHtml(msg);
    t.classList.add("on");
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove("on"); }, 2800);
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var pm = t.closest("[data-pmode]");
    if (pm) { setMode(pm.getAttribute("data-pmode")); return; }

    var vt = t.closest(".vtab");
    if (vt && !vt.disabled) { switchVariant(vt); return; }

    var th = t.closest("[data-bild]");
    if (th) {
      $$(".gal-thumb").forEach(function (b) { b.setAttribute("aria-pressed", b === th ? "true" : "false"); });
      var img = $("#gal-img");
      if (img) {
        img.removeAttribute("srcset");
        img.src = th.getAttribute("data-bild");
      }
      return;
    }

    var pq = t.closest("[data-pq]");
    if (pq) {
      var i = $("#pdpqty");
      if (i) i.value = Math.max(1, Math.min(999, (parseInt(i.value, 10) || 1) + parseInt(pq.getAttribute("data-pq"), 10)));
      return;
    }

    var lp = t.closest("[data-line-plus]"), lm = t.closest("[data-line-minus]");
    if (lp || lm) {
      var idx = (lp || lm).getAttribute(lp ? "data-line-plus" : "data-line-minus");
      var inp = $('[data-line="' + idx + '"]');
      if (inp) {
        inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + (lp ? 1 : -1));
        var f = $("#cart-form");
        if (f) f.submit();
      }
      return;
    }

    var dq = t.closest("[data-dq]");
    if (dq) {
      var key = dq.getAttribute("data-dq");
      var item = lastCart && lastCart.items.filter(function (x) { return x.key === key; })[0];
      if (item) changeLine(key, Math.max(0, item.quantity + parseInt(dq.getAttribute("data-d"), 10)));
      return;
    }
    var drm = t.closest("[data-drm]");
    if (drm) { changeLine(drm.getAttribute("data-drm"), 0); return; }

    if (t.closest("[data-cartopen]")) { e.preventDefault(); openDrawer(); return; }
    if (t.closest("[data-burger]")) {
      var mn = $("#mobnav");
      if (mn) { mn.classList.add("on"); mn.setAttribute("aria-hidden", "false"); mn.inert = false; }
      var sc = $("#scrim"); if (sc) sc.classList.add("on");
      document.body.style.overflow = "hidden";
      return;
    }
    if (t.closest("[data-close]") || t.id === "scrim") { closeAll(); return; }
  });

  document.addEventListener("change", function (e) {
    var dqi = e.target.closest && e.target.closest("[data-dqi]");
    if (dqi) changeLine(dqi.getAttribute("data-dqi"), Math.max(0, parseInt(dqi.value, 10) || 0));
  });

  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f.hasAttribute("data-warenkorb-form")) return;
    e.preventDefault();
    addToCart(f);
  });

  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });

  window.addEventListener("scroll", function () {
    var h = $("#site-header");
    if (h) h.classList.toggle("stuck", window.scrollY > 8);
  }, { passive: true });

  syncMode();
  $$(".pcard .vtab[aria-pressed='true'][data-vbild]").forEach(switchVariant); fetchCart().then(function (c) { renderDrawer(c); });
})();
